import React, { useEffect } from 'react';
import { BoxDataType } from '.';
import { PurchaseDetailsBox } from './PurchaseDetailsBox';
import en from '../../../../lang/en-us';
import { UPDATE_PURCHASE_INFO } from '../../../../redux-store/types/newPurchase';
import { useDispatch } from 'react-redux';
import { CheckBoxField } from '../../../../lib/CheckBoxField';
import { RadioGroup, FormControlLabel, Radio } from '@material-ui/core';

const { common, dbCommercial, dashboard } = en;

const initialValues = {
    id: '',
    name: '',
    relation: '',
    percentage: '',
    dob: '',
    pan: '',
    address1: '',
    gender: '',
    address2: '',
    address3: '',
    city: '',
    state: '',
    country: '',
    pincode: '',
    nomineeGuardian: {
        name: '',
        pan: '',
        pekrn: '',
        dob: '',
    },
};
export default function NomineeDetailsPurchase(props: any) {
    const [nomineeDetailsArray, setNomineeDetails] = React.useState<BoxDataType[][]>([]);
    //try fetching details of nominee from props
    const {
        apiData: { nominees = [], nomineeFlag = false, nomineeInSoa = 'N' },
        kfinFlag,
    } = props;
    const dispatch = useDispatch();
    useEffect(() => {
        const nomineeUiData = nominees.map((nominee: any) => {
            let nomineeDetails: BoxDataType[] = [
                {
                    label: 'Name',
                    value: nominee.name,
                    isEditable: false,
                    apiKey: 'name',
                    name: 'name',
                },
                {
                    label: 'Relation',
                    value: nominee.relation,
                    isEditable: false,
                    apiKey: 'relation',
                    name: 'relation',
                },
                {
                    label: 'Share',
                    value: `${nominee.percentage}%`,
                    isEditable: false,
                    apiKey: 'share',
                    name: 'share',
                },
                {
                    label: 'Gender',
                    value: nominee.gender,
                    isEditable: false,
                    apiKey: 'gender',
                    name: 'gender',
                },
            ];
            return nomineeDetails;
        });
        setNomineeDetails(nomineeUiData);
    }, []);

    const handleDelete = (index: number) => {
        const filteredNominees = nomineeDetailsArray.filter((_: any, i: number) => i !== index);
        dispatch({
            type: UPDATE_PURCHASE_INFO,
            body: { nominees: nominees.filter((_: any, i: number) => i !== index) },
        });
        setNomineeDetails(filteredNominees);
        props.resetError();
    };
    const handleAddNominee = () => {
        let nomineeDetails: BoxDataType[] = [
            {
                label: 'Name',
                value: '',
                isEditable: true,
                apiKey: 'name',
                name: 'name',
            },
            {
                label: 'Relation',
                value: '',
                isEditable: true,
                apiKey: 'relation',
                name: 'relation',
            },
            {
                label: 'Share',
                value: '',
                isEditable: true,
                apiKey: 'share',
                name: 'share',
            },
        ];
        setNomineeDetails((prevState: any) => {
            return [...prevState, nomineeDetails];
        });
        dispatch({
            type: UPDATE_PURCHASE_INFO,
            body: { nominees: [...nominees, initialValues], nomineeFlag: false },
        });
    };

    const handleNomineeFlag = () => {
        dispatch({
            type: UPDATE_PURCHASE_INFO,
            body: { nomineeFlag: !nomineeFlag },
        });
    };

    const NoNomineeCheckBox = (
        <>
            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                <h2 style={{ marginRight: 20 }}>
                    {dbCommercial.newPurchase.leftMenu.nomineeDetails}
                </h2>
                <CheckBoxField
                    label={dbCommercial.profileDetails.nominees.noNominee}
                    value={nomineeFlag}
                    onChange={handleNomineeFlag}
                />
            </div>
            {!nomineeFlag && nomineeDetailsArray.length === 0 && props.errorSection && (
                <div>
                    {' '}
                    <p style={{ color: 'red' }}> {props.errorSection.message}</p>{' '}
                </div>
            )}
        </>
    );

    if (!nomineeDetailsArray.length || nomineeFlag) {
        return (
            <div className="purchase-section">
                {NoNomineeCheckBox}
                {nomineeDetailsArray.length < 3 && (
                    <div className="add-nominee-btn">
                        <a
                            onClick={() => {
                                handleAddNominee();
                                props.resetError();
                            }}
                        >
                            + Add Nominee
                        </a>
                    </div>
                )}
            </div>
        );
    }

    return (
        <div className="purchase-section">
            {NoNomineeCheckBox}
            {nomineeDetailsArray.map((nomineeDetails, index) => (
                <PurchaseDetailsBox
                    boxDetails={nomineeDetails}
                    heading={`Nominee ${index + 1}`}
                    editRedirect={`${props.isin}/edit/nominee`}
                    kfinFlag={kfinFlag}
                    index={index + 1}
                    canDelete={true}
                    handleDelete={handleDelete}
                    errorSection={
                        !props?.errorSection?.index
                            ? props.errorSection
                            : props?.errorSection?.index === index
                            ? props.errorSection
                            : null
                    }
                />
            ))}
            {!nomineeFlag && (
                <div className="nominee-in-soa-checkbox">
                    <p>{dashboard.UpdateNominee.includeInSOA}</p>
                    <p style={{ marginTop: '20px' }}>Display of Nominees:</p>
                    <RadioGroup
                        name="nomineeInSoa"
                        value={nomineeInSoa}
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            marginTop: '20px',
                        }}
                        onChange={(e) =>
                            dispatch({
                                type: UPDATE_PURCHASE_INFO,
                                body: { nomineeInSoa: e.target.value },
                            })
                        }
                    >
                        <FormControlLabel value="Y" control={<Radio />} label="Yes" />
                        <FormControlLabel value="N" control={<Radio />} label="No" />
                    </RadioGroup>
                </div>
            )}

            {nomineeDetailsArray.length <= 2 && (
                <div className="add-nominee-btn">
                    <a onClick={handleAddNominee}>+ Add Nominee</a>
                </div>
            )}
        </div>
    );
}
